import { render, staticRenderFns } from "./Product1101002000011ogcbd.vue?vue&type=template&id=2b21aa4a"
import script from "./Product1101002000011ogcbd.vue?vue&type=script&lang=js"
export * from "./Product1101002000011ogcbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b21aa4a')) {
      api.createRecord('2b21aa4a', component.options)
    } else {
      api.reload('2b21aa4a', component.options)
    }
    module.hot.accept("./Product1101002000011ogcbd.vue?vue&type=template&id=2b21aa4a", function () {
      api.rerender('2b21aa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1101002000011ogcbd.vue"
export default component.exports